import { useUser } from '@shared/hooks';
import { useDeleteProgramFromFavoriteMutation } from '@src/api/api-hooks/programs/useDeleteProgramFromFavoriteMutation.ts';
import { useMakeProgramFavoriteMutation } from '@src/api/api-hooks/programs/useMakeProgramFavoriteMutation.ts';
import { useAppDispatch, useAppSelector } from 'library/hooks/common';
import { showPopup } from 'library/redux/modal';
import { selectTab } from 'library/redux/programs';

/**
 *
 * @param programId {number} айди программы
 *
 * хук управляет добавлением/удалением программ в избранное
 * если пользователь снял отметку избранной программы, находясь на вкладке "избранное",
 * программу нужно удалить из списка избранных
 *
 * сама отметка "программа в избранном" служит чем-то вроде закладки для программ,
 * которые пользователь собирается в будущем покупать
 *
 * соответственно, пользователь не может добавлять в избранное свои собственные программы
 */

interface Props {
  programId: number;
  isPaid?: boolean;
  isFavorite?: boolean;
}

export const useFavorite = ({ programId, isPaid, isFavorite }: Props) => {
  const dispatch = useAppDispatch();
  const tab = useAppSelector(selectTab);
  // const { data: program } = useGetProgramQuery(programId);
  const { mutateAsync: makeProgramFavorite } = useMakeProgramFavoriteMutation();
  const { mutateAsync: deleteProgramFromFavorite } = useDeleteProgramFromFavoriteMutation();
  // const { program, updateProgram, removeProgram } = useProgram(programId);
  const { isAuth } = useUser();

  const showFavorite = isAuth && !isPaid;

  const addToFavorite = async (withoutNotify?: boolean) => {
    // if (!program) return;

    try {
      // updateProgram(programId, { favorite: true });
      await makeProgramFavorite({ id: programId });
      !withoutNotify &&
        dispatch(showPopup({ type: 'success', text: 'Программа добавлена в избранное' }));

      // if (res.status !== 201) {
      //   throw res;
      // }
    } catch (error) {
      console.error(error);
      // updateProgram({id:programId, programData: { favorite: false }});
      // updateProgram(programId, { favorite: false });
      !withoutNotify &&
        dispatch(showPopup({ type: 'error', text: 'Не удалось добавить программу в избранное' }));
    }
  };

  const removeFromFavorite = async () => {
    // if (!program) return;

    try {
      // updateProgram(programId, { favorite: false });
      if (tab.title === 'Избранные') {
        // dispatch(removeProgram(program.pk));
      } else {
        // updateProgram(programId, { favorite: false });
      }

      // await programsService.removeProgramFromFavorite(program.pk);
      await deleteProgramFromFavorite({ id: programId });
      // removeProgram(program.pk);
      dispatch(showPopup({ type: 'success', text: 'Программа удалена из избранного' }));
    } catch (error) {
      console.error(error);
      // updateProgram(programId, { favorite: true });
      // TODO add/remove program to "my" tab
      dispatch(showPopup({ type: 'error', text: 'Не удалось удалить программу из избранного' }));
    }
  };

  const getFavoriteMenu = () => {
    return isFavorite
      ? {
          onClick: removeFromFavorite,
          text: 'Удалить из избранного',
        }
      : {
          onClick: addToFavorite,
          text: 'Добавить в избранное',
        };
  };

  return {
    addToFavorite,
    removeFromFavorite,
    favoriteBtn: getFavoriteMenu(),
    showFavorite,
  };
};
